import { combineEpics } from 'redux-observable';

import initEpic from './init.epic';
import fetchEpic from './fetch.epic';

export default combineEpics(initEpic, fetchEpic);
